module.exports = __webpack_public_path__ + "static/alp-8440e5474804b3a516c817f13871f7ac.png";